export default __webpack_public_path__ + "static/media/house.dc29e96c.png";